import { IUserForm } from '../interfaces/IUserForm';

export class UserForm implements IUserForm {
    secMemberships;
    confirmPassword;
    diagnosis;
    firstName;
    lastName;
    middleName;
    phoneHome;
    phoneCell;
    token;
    email;
    address: {
        state: {
            idState;
        },
        province;
        address1;
        address2;
        city;
        zipcode;
        country: {
            idCountry;
        },
        region: {
            id;
        }
    };
    language: {
        idLanguage;
    };
    clinic:{
        customsFieldsPerClinic;
    };

    constructor() {
        this.email = '';
        this.firstName = '';
        this.lastName = '';
        this.middleName = '';
        this.diagnosis = '';
        this.phoneHome = '';
        this.phoneCell = '';
        this.address = {
            state: {
                idState: ''
            },
            province: '',
            address1: '',
            address2: '',
            city: '',
            zipcode: '',
            country: {
                idCountry: ''
            },
            region: {
                id: ''
            }
        };
        this.language = {
            idLanguage: ''
        };
        this.secMemberships = [];
        this.secMemberships.push({ 'password': '', 'oldPassword': '' });
        this.confirmPassword = '';
        this.clinic = {
            customsFieldsPerClinic: []
        };
    }

    populateUser(data) {
        this.email = data.username;
        this.firstName = data.firstName;
        this.middleName = data.middleName || '';
        this.lastName = data.lastName;
        this.diagnosis = data.diagnosis;
        this.phoneHome = data.phoneHome || '';
        this.phoneCell = data.phoneCell || '';
        if (data.address) {
            this.address.province = data.address.province || '';
            this.address.address1 = data.address.address1 || '';
            this.address.address2 = data.address.address2 || '';
            this.address.city = data.address.city || '';
            this.address.zipcode = data.address.zipcode || '';
            if (data.address.state) {
                this.address.state.idState = data.address.state.idState || '';
            }
            if (data.address.country) {
                this.address.country.idCountry = data.address.country.idCountry || '';
            }
            if (data.address.region) {
                this.address.region.id = data.address.region.id || '';
            }
        }
        if (data.language){
            this.language.idLanguage = data.language.idLanguage;
        }
        if(data.clinic){
            this.clinic = data.clinic;
        }
    }
}
